import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4021b473&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=4021b473&lang=scss&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4021b473",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4021b473')) {
      api.createRecord('4021b473', component.options)
    } else {
      api.reload('4021b473', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4021b473&scoped=true&", function () {
      api.rerender('4021b473', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/seller/components/channel/index.vue"
export default component.exports